import React from 'react';
import './Error.css';
const Error = () => {
    return (
       <div>
          <main className="body">
            <h1 className="errorheader">DARN.</h1>
            <h2 className="errorText">LOOKS LIKE THIS PAGE DOES NOT EXIST.</h2>
            </main>
       </div>
    );
}
 
export default Error;